import type { Unset } from "../../event/head";
import synteticLinkMove from "./linkMove";
import synteticNextPageImpression from "./nextPageImpression";
import synteticPageImpression from "./pageImpression";
import synteticBecomeVisible from "./visible";

/**
 *
 *
 */
export const synteticTracking: (readonly [
  synteticEvent: string,
  register: (element: HTMLElement) => Unset,
])[] = [
  synteticPageImpression,
  synteticBecomeVisible,
  synteticNextPageImpression,
  synteticLinkMove,
];
